import ko from "knockout";
import "flow/extensions/koMeta";
import { MaybeObservable, MaybeObservableAttributes } from "flow/interfaces/MaybeObservable";
import viewHtml from "./checkbox.html";
import createEnabler from "flow/koHelpers/createEnablerDisabler";
import { interceptAttributesWithDefaults } from "flow/koHelpers/interceptAttributes";
import { selectLabel } from "flow/koHelpers/selectParam";

export interface ICheckboxParams {
    attr?: MaybeObservableAttributes;
    bold?: boolean;
    checked: MaybeObservable<boolean>;
    checkedValue?: MaybeObservable<any>;
    enable?: MaybeObservable<boolean>;
    disable?: MaybeObservable<boolean>;
    meta?: MaybeObservable<string>;
    text?: MaybeObservable<string>;
    suppressErrorMessage?: boolean;
    name?: MaybeObservable<string>;
}

ko.components.register("ko-checkbox", {
    viewModel: function (params: ICheckboxParams) {
        this.checked = params.checked;
        this.takeInnerHtml = false;

        this.checkedValue = !!params.checkedValue ? params.checkedValue : undefined;

        this.fontWeight = !!params.bold ? 700 : 400;

        if (params.meta || params.text) {
            this.text = selectLabel(params.meta, params.text);
        } else {
            this.takeInnerHtml = true;
        }

        this.enable = createEnabler(params.enable, params.disable);

        this.attributes = interceptAttributesWithDefaults(
            {
                name: params.name
            },
            params.attr
        );

        this.suppressErrorMessage = params.suppressErrorMessage ?? false;
    },
    template: viewHtml,
    synchronous: true
});
